import { useState } from "react";
import useAZZKUProfessionsSearch from "hooks/AZZKU/useAZZKUProfessionsSearch";

import SearchInput from "components/SearchInput";

export default function SearchProfessionForm({ onSubmit }) {

   const [ profession, setProfession ] = useState( null );

   return (
      <SearchInput
         name="profession"
         value={ profession }
         placeholder="Szukaj zawodów"
         style={{ maxWidth: "500px" }}
         useOptionsHook={ useAZZKUProfessionsSearch }
         onChange={( n, v ) => {
            if ( v ) {
               onSubmit( v.value );
               setProfession( null );
            } else {
               setProfession( v );
            }
         }}
      />
   )
}